import React, { useEffect, useState } from 'react';
import { useParams, useLocation } from 'react-router-dom';
import axios from 'axios';
import { Paper, Typography, TextField, Button } from '@mui/material';
import './detailTalent.css';

const NotesTab = ({ talentId: propTalentId, origine , initialNotes}) => {

  const params = useParams();
  const talentId = propTalentId || params.talentId;
  const API_BASE = process.env.REACT_APP_API_BASE_URL;
  const [note, setNote] = useState('');
  const [notes, setNotes] = useState([]);

  const isCandidat = origine === 'Candidat';

  useEffect(() => {
    setNotes(initialNotes || []);
  }, [initialNotes]);
  const handleAddNote = async () => {
    if (!note.trim()) return;
  
    try {
      const endpoint = isCandidat
        ? `${API_BASE}/api/admin/candidat/${talentId}/note`
        : `${API_BASE}/api/recruteur/talent/${talentId}/note`;
  
      const res = await axios.put(endpoint, { note: note.trim() });
  
      if (Array.isArray(res.data.notes)) {
        setNotes(res.data.notes);
      } else if (Array.isArray(res.data.note)) {
        setNotes(res.data.note);
      } else if (res.data.note) {
        setNotes((prev) => [...prev, res.data.note]);
      }
      
  
      setNote('');
    } catch (err) {
      console.error("Erreur lors de l'ajout de la note :", err);
    }
  };
  
  

  return (
    <Paper elevation={3} className="notes-container">
      <Typography variant="h6" gutterBottom>Ajouter une note</Typography>
      <TextField
        multiline
        minRows={2}
        fullWidth
        value={note}
        onChange={(e) => setNote(e.target.value)}
        placeholder="Écrivez une note..."
        className="note-textarea"
      />
      <Button variant="contained" onClick={handleAddNote} sx={{ mt: 2 }}>
        Ajouter
      </Button>
      {notes
        .filter((n) => {
          if (!n) return false;
          if (typeof n === "string") return n.trim() !== "";
          if (typeof n === "object") return n.note && n.note.trim() !== "";
          return false;
        })
        .map((n, i) => (
        <Paper key={i} className="note-entry">
          <Typography variant="caption">{new Date().toLocaleString()}</Typography>
          <Typography>{n}</Typography>
        </Paper>
      ))}
    </Paper>
  );
};


export default NotesTab;
